// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"LabsInboxSettingsContainer_checkboxContainer__xI5VH","checkboxDescription":"LabsInboxSettingsContainer_checkboxDescription__v6cjQ"};